import * as Sugar from 'sugar';
import flatpickr from 'flatpickr';
const japanese = require('flatpickr/dist/l10n/ja').default.ja;

export const searchCalendar = () => {
  const sel: string = '.js-calendar';
  const df: string = 'Y/m/d';
  const today = new Sugar.Date().reset();
  let min = today.clone().addDays(1).raw;
  let max = today.clone().addYears(1).raw;

  flatpickr(sel, {
    locale: japanese,
    dateFormat: df,
    defaultDate: min,
    minDate: min,
    maxDate: max,
    disableMobile: true,
  });
};
